__turbopack_context__.v({
  "buttonRow": "MdxClient-module__Z1j56W__buttonRow",
});
